import FootprintReportDashboard from '../pages/FootprintReport';

const footprintReportRoute = {
  public: [],
  auth: [
    {
      name: 'footprint_report',
      path: '/report/footprint',
      permissions: ['CNC-ADMIN', 'CNC-ANALYST'],
      component: FootprintReportDashboard,
    },
  ],
};

export default footprintReportRoute;
